import { defineMessages } from 'react-intl';

export default defineMessages({
  typeLabel: {
    id: 'frontbucket.privacyFilter',
    description: 'Button name for privacy filter',
    defaultMessage: 'Privacy',
  },
  privateLabel: {
    id: 'frontbucket.privacyFilter.privateLabel',
    description: 'Private option for the privacy filter',
    defaultMessage: 'Private',
  },
  publicLabel: {
    id: 'frontbucket.privacyFilter.publicLabel',
    description: 'Public option for the privacy filter',
    defaultMessage: 'Public',
  },
});
